import { render, staticRenderFns } from "./SliderForm.vue?vue&type=template&id=7d5b5ac3&"
import script from "./SliderForm.vue?vue&type=script&lang=js&"
export * from "./SliderForm.vue?vue&type=script&lang=js&"
import style0 from "./SliderForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports